export function enabledOptions(options) {
  return options.map((option, index) => option.disabled ? -1 : index).filter(index => index >= 0);
}

export function moveOption(options, active, key) {
  const indices = enabledOptions(options);
  if (!indices.length) return -1;
  if (key === 'Home') return indices[0];
  if (key === 'End') return indices.at(-1);
  const current = indices.indexOf(active);
  if (current < 0) return key === 'ArrowUp' ? indices.at(-1) : indices[0];
  return indices[(current + (key === 'ArrowUp' ? -1 : 1) + indices.length) % indices.length];
}

export function matchOption(options, query, active) {
  const prefix = query.normalize('NFKC').toLocaleLowerCase();
  const indices = enabledOptions(options);
  // Search after the active option, wrapping once, so repeated letters cycle.
  const start = indices.indexOf(active) + 1;
  const ordered = [...indices.slice(start), ...indices.slice(0, start)];
  return ordered.find(index => options[index].label.normalize('NFKC').toLocaleLowerCase().startsWith(prefix)) ?? active;
}
